import { formatDistanceToNow } from 'date-fns';
import { pt } from 'date-fns/locale';

export const timeAgo = (iso) => {
  if (!iso) return '';
  try {
    return formatDistanceToNow(new Date(iso), { addSuffix: true, locale: pt });
  } catch {
    return iso;
  }
};

export const maskIp = (ip) => {
  if (!ip) return '—';
  if (ip.includes('.')) {
    const parts = ip.split('.');
    if (parts.length === 4) return `${parts[0]}.${parts[1]}.x.x`;
  }
  if (ip.includes(':')) {
    const parts = ip.split(':');
    return `${parts.slice(0, 2).join(':')}:…`;
  }
  return ip;
};

export const formatBytes = (bytes) => {
  if (!bytes) return '—';
  if (bytes < 1024) return `${bytes} B`;
  if (bytes < 1024 * 1024) return `${(bytes / 1024).toFixed(1)} KB`;
  return `${(bytes / 1024 / 1024).toFixed(1)} MB`;
};

// Photos created before consent capture (May 2026) may not carry the field.
// fogosapi treats missing `public` as true; mirror that here.
export const isPhotoPublic = (photo) => {
  if (!photo) return true;
  return photo.public !== false;
};

export const photoSignature = (photo) => {
  const s = photo?.signature;
  if (typeof s !== 'string') return null;
  const trimmed = s.trim();
  return trimmed || null;
};

export const formatLisbon = (iso) => {
  if (!iso) return '—';
  try {
    return new Date(iso).toLocaleString('pt-PT', {
      timeZone: 'Europe/Lisbon',
      dateStyle: 'short',
      timeStyle: 'medium',
    });
  } catch {
    return iso;
  }
};
